// @ts-expect-error Could not find a declaration file
import Actions from 'AdsUI/lib/Actions';
import { Map as ImmutableMap } from 'immutable';

const AutomationReducer = (state = ImmutableMap({
  contactLists: [],
  workflows: {}
}), action) => // any because response shape varies
{
  if (!action.payload) {
    return state;
  }

  switch (action.type) {
    case Actions.AUTOMATION_CONTACT_LIST_FETCH_SUCCEEDED:
      {
        return state.set('contactLists', action.payload);
      }

    case Actions.AUTOMATION_ALL_WORKFLOWS_FETCH_SUCCEEDED:
      {
        return state.set('workflows', action.payload);
      }

    default:
      return state;
  }
};

export default AutomationReducer;